/** See `src/i18n/locales/en/communications.ts`. */
export const communications = {
  page: {
    title: 'Kommunikation',
    lead: 'Benachrichtigungen für {{company}} erstellen und planen.',
    noScope: 'Wählen Sie ein Unternehmen, um dessen Kommunikation zu sehen.',
    forbidden: 'Sie dürfen die Kommunikation dieses Unternehmens nicht sehen.',
  },
  composer: {
    title: 'Neue Benachrichtigung',
    titleField: 'Titel',
    message: 'Nachricht',
    category: 'Kategorie',
    audience: 'Zielgruppe',
    date: 'Datum',
    time: 'Uhrzeit',
    callToAction: 'Call-to-Action',
    quietHours: 'Ruhezeiten beachten',
    quietHoursHint: 'Zustellung außerhalb von 08:00–20:00 Uhr verzögern.',
    submit: 'Als Entwurf speichern',
    schedule: 'Einplanen',
    send: 'Jetzt senden',
  },
  categories: {
    algemeen: 'Allgemein',
    veiligheid: 'Sicherheit',
    evenement: 'Veranstaltung',
    vitaliteit: 'Vitalität',
    hr: 'HR',
  },
  audiences: {
    iedereen: 'Alle',
    management: 'Management',
    per_afdeling: 'Pro Abteilung',
    per_locatie: 'Pro Standort',
  },
  status: {
    concept: 'Entwurf',
    ingepland: 'Geplant',
    verzonden: 'Gesendet',
  },
  log: {
    title: 'Sendeprotokoll',
    empty: 'Noch keine Kommunikation.',
    columns: {
      message: 'Nachricht',
      category: 'Kategorie',
      reach: 'Reichweite',
      openRate: 'Öffnungsrate',
      status: 'Status',
    },
  },
  actions: {
    new: 'Neue Benachrichtigung',
    cancel: 'Abbrechen',
    markScheduled: 'Als geplant markieren',
    markSent: 'Als gesendet markieren',
  },
} as const;
